<template>
  <vs-popup :active.sync="popupActive" :title="$t('payments.create')" class="holamundo" id="paymentApprovalModal">
    <ValidationObserver class="w-full" ref="validator" v-slot="{ invalid }">
      <form @submit.prevent="submit()">
        <base-multiselect
          v-if="!paymentData.hideProject"
          :allow-empty="false"
          :input-label="$t('payments.table.project')"
          :loading="loadingSelect"
          :max-height="200"
          :options="projects"
          @search-change="searchProjects"
          class="mb-3"
          :custom-label="makeProjectLabel"
          track-by="id"
          v-model="paymentData.project"/>
        <base-input :label-placeholder="$t('payments.table.amount')"
                    :min="0"
                    :name="$t('payments.table.amount')" class="w-full"
                    rules="required|numeric"
                    type="number"
                    v-model="paymentData.amount"/>
        <base-button :disabled="invalid" button="filled" class="w-full mb-5 mt-2" color="success" type="submit">
          {{ $t('payments.create') }}
        </base-button>
      </form>
    </ValidationObserver>
  </vs-popup>
</template>

<script>
  import EventBus from "../../utilities/eventBus";
  import Payments from "../../services/Payments";
  import Projects from "../../services/Projects";

  export default {
    name: "CreatePaymentModal",
    data: () => ({
      loadingSelect: false,
      popupActive: false,
      paymentData: {},
      projects: [],
    }),
    methods: {
      show (payment) {
        this.popupActive = true;
        this.paymentData = payment;
      },
      hide () {
        this.paymentData = {};
        this.popupActive = false;
      },
      async submit () {
        const isValid = await this.$refs.validator.validate();
        if (!isValid) return;
        if (this.paymentData.project) {
          this.paymentData.project_id = this.paymentData.project.id;
        }
        Payments.create(this.paymentData).then(() => {
          this.onCreated();
        }, error => {
          this.$notificationService.error(error.message);
        });
      },
      onCreated () {
        EventBus.$emit('paymentCreated');
        this.hide();
      },
      searchProjects (search) {
        this.loadingSelect = true;
        const query = {search, perPage: 5, include: 'client'}
        Projects.list(query).then(({data}) => {
          this.projects = data;
        }).finally(() => {
          this.loadingSelect = false;
        });
      },
      makeProjectLabel({client,name}) {
        return `${client.name} - ${name}`
      }
    },
    mounted () {
      EventBus.$on('openCreatePaymentModal', (payment) => this.show(payment));
    }
  }
</script>

<style scoped>

</style>
